import MultiAutoComplete from '../MultiAutoComplete';
import React from 'react';

const buildOption = (role) => {
  // console.log('role', role);
  if (role) {
    return { label: role.name, value: role };
  }

  return null;
};

const loadOptions = (roles) => (query) => {
  // console.log('loadOptions', roles, query);
  const queryLC = (query||'').toLowerCase();
  return Promise.resolve(roles.filter(r => r.name.toLowerCase().indexOf(queryLC) >= 0).map(buildOption));
}

const RoleAutoComplete = ({ id = 'role', label, helperText, fullWidth, value, onChange, roles, isMulti, allowCreate, ...other }) => {
  // console.log('buildVal', buildOption(value));
  return (<MultiAutoComplete
    id={id}
    label={label}
    helperText={helperText}
    loadOptions={loadOptions(roles)}
    value={isMulti ? (value || []).map(buildOption) : buildOption(value)}
    onChange={(value) => {
      // console.log('optselected', value);
      return onChange(isMulti ? value.map(opt => opt.value) : value.value);
    }}
    {...other}
    isMulti={isMulti}
    allowCreate={allowCreate}
  />);
};

export default RoleAutoComplete;



// WEBPACK FOOTER //
// ./src/components/Common/RoleAutoComplete/index.js